import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "title", "className", "naked"],
  _excluded2 = ["children", "className", "autoCollapse"],
  _excluded3 = ["children", "className"],
  _excluded4 = ["children", "noVPadding", "className", "fill"],
  _excluded5 = ["children", "pad", "className", "scrollable", "loading"];
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import prefix from '../../utils/prefix';
import ProgressSpinner from '../ProgressSpinner';
import './styles.sass';
export var Widget = /*#__PURE__*/React.forwardRef(function Widget(_ref, ref) {
  var children = _ref.children,
    title = _ref.title,
    className = _ref.className,
    naked = _ref.naked,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cx('widget', className, naked && 'widget--naked')
  }, props), title && /*#__PURE__*/React.createElement(WidgetHeader, null, /*#__PURE__*/React.createElement(WidgetTitle, null, title)), children);
});
Widget.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  pad: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  naked: PropTypes.any
};
export var WidgetHeader = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    className = _ref2.className,
    autoCollapse = _ref2.autoCollapse,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cx('widget-header', autoCollapse && 'widget-header--auto-collapse', className)
  }, props), children);
});
WidgetHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  autoCollapse: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  naked: PropTypes.any
};
export var WidgetTitle = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cx('widget-header-segment widget-title', className)
  }, props), children);
});
WidgetTitle.propTypes = {
  pad: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};
export var WidgetHeaderSegment = function WidgetHeaderSegment(_ref4) {
  var children = _ref4.children,
    noVPadding = _ref4.noVPadding,
    className = _ref4.className,
    fill = _ref4.fill,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('widget-header-segment', noVPadding && 'widget-header-segment--no-vpadding', fill && 'widget-header-segment--fill', className)
  }, props), children);
};
WidgetHeaderSegment.propTypes = {
  noVPadding: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};
var contentModifiers = prefix('widget-content--');
export var WidgetContent = /*#__PURE__*/React.forwardRef(function WidgetContent(_ref5, ref) {
  var children = _ref5.children,
    pad = _ref5.pad,
    className = _ref5.className,
    scrollable = _ref5.scrollable,
    loading = _ref5.loading,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('widget-content', contentModifiers({
      pad: pad,
      scrollable: scrollable
    }), className)
  }, props, {
    ref: ref
  }), loading ? /*#__PURE__*/React.createElement(WidgetLoading, null) : children);
});
WidgetContent.propTypes = {
  pad: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  scrollable: PropTypes.any
};
export var WidgetLoading = function WidgetLoading(_ref6) {
  var className = _ref6.className,
    children = _ref6.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('widget-loading', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "widget-loading__spinner"
  }, /*#__PURE__*/React.createElement(ProgressSpinner, {
    size: 48,
    color: "#14ABA6"
  })), children && /*#__PURE__*/React.createElement("div", {
    className: "widget-loading__content"
  }, children));
};
WidgetLoading.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
//# sourceMappingURL=index.js.map
